import { useAuth } from '../../context/AuthContext';
import { Link } from 'react-router-dom';
import CompetitionBadge from '../../components/CompetitionBadge';
import { ResultsPanel } from '../admin/AdminDashboard';
import { userRoles } from '../../utils/roles';

// ---------------------------------------------------------------------------
// Viewer results page (10 Sep 2026).
//
// The landing page for a viewer account (users.role = 'observer'). It is the
// admin Results tab and nothing else: the same ResultsPanel the admin sees,
// with no tab bar, so a viewer never learns the names of the other tabs.
// The panel's data comes from GET /api/admin/results, which observer.js
// answers read-only for this role, and the play/download links are the
// static /uploads paths — so nothing on this page can write, and nothing
// on it needs an admin-only route.
//
// The header deliberately has no links: the logo is not a Link to the admin
// dashboard, because for a viewer there is nowhere else to go.
// ---------------------------------------------------------------------------
export default function ViewerResults() {
  const { user, logout } = useAuth();

  // A pure viewer has nowhere else to go, so the header stays link-free for
  // them. Someone GRANTED this page on top of another role (migration 050)
  // arrived from a dashboard and needs the way back.
  const roles = userRoles(user);
  const backTo = roles.includes('admin')      ? { to: '/admin/dashboard',      label: 'Back to admin' }
               : roles.includes('judge')      ? { to: '/judge/dashboard',      label: 'Back to judging' }
               : roles.includes('contestant') ? { to: '/contestant/dashboard', label: 'Back to my entries' }
               : null;

  return (
    <div className="c-page">
      <header className="c-header">
        <span className="c-header__logo">
          <span className="scala">SCALA</span>{' '}
          <span className="scala">FOOM</span>{' '}
          <span className="c-header__logo-sub">Results</span>
          <CompetitionBadge />
        </span>

        <div className="c-header__right">
          {backTo && (
            <Link to={backTo.to} className="c-btn c-btn--sm c-btn--outline" style={{ marginRight: '0.75rem' }}>
              ← {backTo.label}
            </Link>
          )}
          <span className="c-header__user">{user?.full_name}</span>
          <button onClick={logout} className="c-header__logout">
            Sign out
          </button>
        </div>
      </header>

      <main className="c-main">
        <div className="a-panel">
          <ResultsPanel />
        </div>
      </main>
    </div>
  );
}
